import { changeSaleOfferBegin } from '../offer/offer.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { withLatestFrom } from 'rxjs';
import { getMedicSearchState } from './medic-search.selector';
import { setMedicSearchState } from './medic-search.actions';

@Injectable()
export class MedicSearchEffects {
  public resetMedicSearchResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(changeSaleOfferBegin),
      withLatestFrom(this.store.select(getMedicSearchState)),
      map(([_, state]) =>
        setMedicSearchState({
          nameFieldContent: state.nameFieldContent,
          saleOfferBegin: state.saleOfferBegin,
          zipCodeFieldContent: state.zipCodeFieldContent,
          searchResults: null,
        }),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store,
  ) {}
}
